import React, { useContext, useEffect, useState } from 'react'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { UpdateClientStatus } from 'api/Clients/Types/UpdateClientStatus'
import { UpdateCompanyDetailsDto } from 'api/Clients/Types/UpdateCompanyDetailsDto'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useAppDispatch, useAppSelector } from 'store'
import {
  fetchClientCompanyTypesAction,
  fetchClientWorldCheckStatusAction,
  fetchLegalBasesTypesAction,
  fetchOwnershipStructuresAction,
} from 'store/clients/clients.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { AuthSessionContext } from 'utils/AuthContext'
import { isEmpty } from 'utils/is-empty'

import { ClientNavigation, ClientTab } from '../../Navigation/ClientNavigation'
import { ClientDetailsCorporateForm } from './ClientDetailsCorporateForm'

type ClientDetailsCorporateProps = {
  data: ClientDetailedDto
  forceRefresh(): void
  updateClientStatus(values: UpdateClientStatus): void
}

export const ClientDetailsCorporatePage: React.FC<ClientDetailsCorporateProps> = (props) => {
  const clientsApiClient = useApiClient(ClientsApiClient)

  const [auth] = useContext(AuthSessionContext)
  const [isEdit, setEdit] = useState(false)

  const legalBasesTypes = useAppSelector((state) => state.clients.legalBasesTypes)
  const companyTypes = useAppSelector((state) => state.clients.companyTypes)
  const worldCheckStatuses = useAppSelector((state) => state.clients.worldCheckStatus)
  const ownershipStructures = useAppSelector((state) => state.clients.ownershipStructures)

  const permissions = auth?.permissions || []

  const setToast = useContext(ToastContext)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (isEmpty(legalBasesTypes)) {
      dispatch(fetchLegalBasesTypesAction(clientsApiClient))
    }
    if (isEmpty(companyTypes)) {
      dispatch(fetchClientCompanyTypesAction(clientsApiClient))
    }
    if (isEmpty(worldCheckStatuses)) {
      dispatch(fetchClientWorldCheckStatusAction(clientsApiClient))
    }
    if (isEmpty(ownershipStructures)) {
      dispatch(fetchOwnershipStructuresAction(clientsApiClient))
    }
  }, [dispatch, legalBasesTypes]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = async (values: UpdateCompanyDetailsDto) => {
    await clientsApiClient.updateClientCorporateDetails(values, false)
    setToast(successToast('Client updated successfully.'))
    props.forceRefresh()
  }

  return (
    <React.Fragment>
      <ClientNavigation
        isEdit={isEdit}
        data={props.data}
        tab={ClientTab.CORPORATE}
        updateClientStatus={props.updateClientStatus}
      />
      <ClientDetailsCorporateForm
        data={props.data}
        isEdit={isEdit}
        setEdit={setEdit}
        companyTypes={companyTypes}
        worldCheckStatuses={worldCheckStatuses}
        permissions={permissions}
        onSubmit={handleSubmit}
      />
    </React.Fragment>
  )
}
